import SpecificationProductionManager from './SpecificationProductionManager';
export default SpecificationProductionManager;
